import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridVue } from "ag-grid-vue";
import { noRowsTemplate } from "@/components/TransactionsPage/noRowsTemplate";
import statusInTable from "@/components/OperationsPage/Deposit/Rial/DirectDebit/DirectDebitTable/StatusInTable/index";
import dayjs from "@/utiles/dayjs";
import $exponent from "@/mixins/exponent";
import $thousandMask from "@/mixins/thousandMask";
import directDebit from "@/services/modules/directDebit";

export default {
  name: "payment-id-table",
  components: { AgGridVue, statusInTable },
  props: [],
  mixins: [$exponent, $thousandMask],
  data() {
    return {
      page: 1,
      loading: false,
      dataTableItem: "",
      gridOptions: null,
      gridApi: null,
      localeText: null,
      columnApi: null,
      paginationPageSize: null,
      paginationNumberFormatter: null,
      item: "10",
      offlinePaymentHeader: null,
      defaultOfflinePaymentHeader: null,
      showOfflinePaymentWithIDData: [],
      showPaginationCount: {}
    };
  },
  computed: {},
  beforeMount() {
    this.gridOptions = {
      overlayNoRowsTemplate: noRowsTemplate.template
    };
    this.offlinePaymentHeader = [
      {
        colId: 0,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.bankName"
        ),
        field: "bankName",
        unSortIcon: true,
        flex: 1,
        width: 90,
        minWidth: 90
      },
      {
        colId: 0,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.paymentDate"
        ),
        field: "date",
        unSortIcon: true,
        flex: 1,
        width: 120,
        minWidth: 120
      },
      {
        colId: 1,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.amount"
        ),
        field: "amount",
        unSortIcon: true,
        flex: 1,
        width: 150,
        minWidth: 150
      },
      {
        colId: 2,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.referBankCode"
        ),
        field: "tracking_code",
        unSortIcon: true,
        flex: 1,
        width: 110,
        minWidth: 110
      },
      {
        colId: 2,
        headerName: this.$t(
          "operationsPage.deposit.category.rial.offline.offlineTable.tableHeader.status"
        ),
        field: "status",
        unSortIcon: true,
        flex: 1,
        width: 100,
        cellRendererFramework: "statusInTable",
        minWidth: 100
      }
    ];
    this.defaultOfflinePaymentHeader = {
      headerClass: "header-table-ag-grid-cell",
      lockPosition: true,
      icons: {
        sortUnSort:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>',
        sortAscending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#c1c6cd"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#500fe9"></path></svg>',
        sortDescending:
          '<svg id="sort_arrows" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" class="v-icon notranslate v-icon--is-component theme--light" style="font-size: 15px; height: 15px; width: 15px;"><rect id="Rectangle_910" data-name="Rectangle 910" width="14" height="14" fill="none"></rect><path id="Down" d="M14.936,13v1.4l-2.968,2.968L9,14.4V13Z" transform="translate(-5 -5)" fill="#500fe9"></path><path id="Up" d="M14.936,17.368v-1.4L11.968,13,9,15.968v1.4Z" transform="translate(-5 -11)" fill="#c1c6cd"></path></svg>'
      }
    };
    this.paginationPageSize = 10;
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.getTransactions(1);
  },
  methods: {
    // offlinePaymentData(page) {
    //   this.showPaginationCount = {};
    //   this.showOfflinePaymentData = [];
    //   OfflinePaymentService.getOfflinePaymentData(page).then(response => {
    //     this.offlinePaymentAction(response.data);
    //     this.showPaginationCount = response.data.pagination;
    //     response.data.data.forEach(elem => {
    //       this.showOfflinePaymentData.push({
    //         amount: this.$thousandMask(elem.amount),
    //         date: this.formatDate(elem.pay_date),
    //         status: { locale: elem.status_locale, style: elem.status_color },
    //         operation: {
    //           transaction_type: "offlinePayment",
    //           drawer: true,
    //           reference_number: elem.id,
    //         },
    //       });
    //     });
    //   });
    // },
    getTransactions(page) {
      directDebit.getAllTransactionList(page).then(response => {
        this.showPaginationCount = {};
        this.showOfflinePaymentWithIDData = [];
        this.showPaginationCount = response.data.pagination;
        response.data.data.forEach(elem => {
          this.showOfflinePaymentWithIDData.push({
            amount: this.$thousandMask(elem.amount),
            date: this.formatDate(elem.created_at),
            tracking_code: elem.tracking_code,
            bankName: elem.gateway.name_fa,
            status: elem.status
          });
        });
      });
    },
    formatDate(date) {
      return dayjs(date).format("YYYY/MM/DD");
    },
    formatTimes(time) {
      return dayjs(time).format("mm : HH");
    }
  }
};
